module.exports = __webpack_public_path__ + "static/media/shiny-dress.7b1a96cb.jpg";